import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import styles from 'styles/components/card.module.scss'
import { Spacer } from 'components/Utility'
import { push } from 'connected-react-router'

type MenuType = {
  dataCy?: string
  description: string
  iconPath: string
  onClick?: () => void
  title: string
  url: string
}

type Props = MenuType & { subMenus?: MenuType[] }

const LargeMenuCard: FC<Props> = (props) => {
  const { dataCy, description, iconPath, onClick, subMenus = [], title, url } = props
  const dispatch = useDispatch()
  return (
    <div className={styles.menu__top} data-cy={`large-menu-card-${dataCy}`}>
      <a
        className={styles.menu__top__wrapper}
        role={'button'}
        onClick={() => {
          if (onClick) {
            onClick()
          } else {
            dispatch(push(url))
          }
        }}
      >
        <div className={styles.menu__top__icon}>
          <img src={iconPath} alt={title} />
        </div>
        <Spacer size={16} axis={'horizontal'} />
        <div>
          <h2 className={styles.menu__top__title}>{title}</h2>
          <Spacer size={8} />
          <p className={styles.menu__top__description}>{description}</p>
        </div>
        <img className={styles.menu__top__arrow} src={'/icon/white/arrow_next.svg'} alt={'進む'} />
      </a>
      {subMenus.length > 0 && <Spacer size={16} />}
      {subMenus.map((subMenu) => {
        return (
          <a
            key={subMenu.url}
            className={styles.menu__sub}
            role={'button'}
            onClick={() => {
              if (onClick) {
                onClick()
              } else {
                dispatch(push(subMenu.url))
              }
            }}
          >
            <div className={styles.menu__sub__icon}>
              <img src={subMenu.iconPath} alt={subMenu.title} />
            </div>
            <Spacer size={16} axis={'horizontal'} />
            <div>
              <h2 className={styles.menu__sub__title}>{subMenu.title}</h2>
              <Spacer size={8} />
              <p className={styles.menu__sub__description}>{subMenu.description}</p>
            </div>
            <img className={styles.menu__sub__arrow} src={'/icon/blue/arrow_next.svg'} alt={'進む'} />
          </a>
        )
      })}
    </div>
  )
}

export default LargeMenuCard
